export enum EmployeesRoutePathsEnum {
  EMPLOYEE = 'employees/:employeeId',
  EMPLOYEES = 'employees',
}
